const DIARY_TEXT_BEFORE = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling.',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_1 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling. I',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_2 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling. It',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_3 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling. It d',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_4 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling. It di',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_5 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling. It did',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_6 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    'My therapist said to try journaling. It didn',
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_7 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn'",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_8 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_9 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't h",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_10 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't he",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_11 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't hel",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_12 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_13 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_14 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great a',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_15 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_16 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at m',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_17 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at me',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_18 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at mes',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_19 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at mess',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_20 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messi',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_21 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messin',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_22 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_23 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing u',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_24 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terrific',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_25 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_26 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--b',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_27 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--bl',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_28 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\n',
    "Don't  give up!",
];

const DIARY_TEXT_29 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nb',
    "Don't  give up!",
];

const DIARY_TEXT_30 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbe',
    "Don't  give up!",
];

const DIARY_TEXT_31 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbec',
    "Don't  give up!",
];

const DIARY_TEXT_32 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbeca',
    "Don't  give up!",
];

const DIARY_TEXT_33 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbecau',
    "Don't  give up!",
];

const DIARY_TEXT_34 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbecaus',
    "Don't  give up!",
];

const DIARY_TEXT_35 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbecause',
    "Don't  give up!",
];

const DIARY_TEXT_36 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    'Nothing can get me down...\nbecause I',
    "Don't  give up!",
];

const DIARY_TEXT_37 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'",
    "Don't  give up!",
];

const DIARY_TEXT_38 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm",
    "Don't  give up!",
];

const DIARY_TEXT_39 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm a",
    "Don't  give up!",
];

const DIARY_TEXT_40 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm al",
    "Don't  give up!",
];

const DIARY_TEXT_41 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm alr",
    "Don't  give up!",
];

const DIARY_TEXT_42 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm alre",
    "Don't  give up!",
];

const DIARY_TEXT_43 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm alrea",
    "Don't  give up!",
];

const DIARY_TEXT_44 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm alread",
    "Don't  give up!",
];

const DIARY_TEXT_45 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already",
    "Don't  give up!",
];

const DIARY_TEXT_46 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already d",
    "Don't  give up!",
];

const DIARY_TEXT_47 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already do",
    "Don't  give up!",
];

const DIARY_TEXT_48 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already dow",
    "Don't  give up!",
];

const DIARY_TEXT_49 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already down",
    "Don't  give up!",
];

const DIARY_TEXT_50 = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already down",
    "Don't, give up!",
];

const DIARY_TEXT_AFTER = [
    'Dear Diary,',
    'I was diagnosed with First World Problem Syndrome.',
    "My therapist said to try journaling. It didn't help.",
    'I am great at messing up',
    'Absolutely terri--fic--ble',
    "Nothing can get me down...\nbecause I'm already down",
    "Don't, give up!",
];

export const DIARY_TRANSFORMATION = [
    DIARY_TEXT_BEFORE,
    DIARY_TEXT_BEFORE,
    DIARY_TEXT_BEFORE,
    DIARY_TEXT_BEFORE,
    DIARY_TEXT_BEFORE,
    DIARY_TEXT_1,
    DIARY_TEXT_2,
    DIARY_TEXT_3,
    DIARY_TEXT_4,
    DIARY_TEXT_5,
    DIARY_TEXT_6,
    DIARY_TEXT_7,
    DIARY_TEXT_8,
    DIARY_TEXT_9,
    DIARY_TEXT_10,
    DIARY_TEXT_11,
    DIARY_TEXT_12,
    DIARY_TEXT_13,
    // No-op.
    DIARY_TEXT_13,
    DIARY_TEXT_13,
    DIARY_TEXT_13,
    DIARY_TEXT_14,
    DIARY_TEXT_15,
    DIARY_TEXT_16,
    DIARY_TEXT_17,
    DIARY_TEXT_18,
    DIARY_TEXT_19,
    DIARY_TEXT_20,
    DIARY_TEXT_21,
    DIARY_TEXT_22,
    DIARY_TEXT_23,
    DIARY_TEXT_24,
    // No-op.
    DIARY_TEXT_24,
    DIARY_TEXT_24,
    DIARY_TEXT_24,
    DIARY_TEXT_25,
    DIARY_TEXT_26,
    DIARY_TEXT_27,
    DIARY_TEXT_28,
    // No-op.
    DIARY_TEXT_28,
    DIARY_TEXT_28,
    DIARY_TEXT_28,
    DIARY_TEXT_29,
    DIARY_TEXT_30,
    DIARY_TEXT_31,
    DIARY_TEXT_32,
    DIARY_TEXT_33,
    DIARY_TEXT_34,
    DIARY_TEXT_35,
    DIARY_TEXT_36,
    DIARY_TEXT_37,
    DIARY_TEXT_38,
    DIARY_TEXT_39,
    DIARY_TEXT_40,
    DIARY_TEXT_41,
    DIARY_TEXT_42,
    DIARY_TEXT_43,
    DIARY_TEXT_44,
    DIARY_TEXT_45,
    DIARY_TEXT_46,
    DIARY_TEXT_47,
    DIARY_TEXT_48,
    DIARY_TEXT_49,
    // No-op.
    DIARY_TEXT_49,
    DIARY_TEXT_49,
    DIARY_TEXT_49,
    DIARY_TEXT_50,
    DIARY_TEXT_AFTER,
];
